import type { ButtonProps } from "@mantine/core";
import { IconFileDownload } from "@tabler/icons-react";
import type { ComponentProps } from "react";
import { IconButton } from "../../../../../../mantine/components/IconButton/IconButton";

type DownloadTemplateButtonProps = ButtonProps & ComponentProps<"button">;

function DownloadTemplateButton(props: DownloadTemplateButtonProps) {
  return (
    <IconButton
      icon={IconFileDownload}
      td="underline"
      variant="subtle"
      {...props}
    >
      Vorlage herunterladen
    </IconButton>
  );
}

export { DownloadTemplateButton };
